/* globals OutlookHotmailDTO */

var jquery = require("jquery");
var CookieService = require("./cookie-service");
var WindowModal = require("./window-modal");
var HabEvents = require('./habitaclia-events');

export default class HotmailOutlookModal {

    constructor(userInfo){
        if (userInfo.user){
            this._modalInfo = userInfo;
            this.cookieService = CookieService;
            this.showModal();
        }
    }

    showModal(){
        var userEmail = this._modalInfo.user.email;
        if(userEmail && userEmail !== null) {
            const expression = new RegExp(/(?:@outlook|@hotmail)+/g);
            const cookieEmail = CookieService.getCookie('outlook-hotmail');
            if(this._modalInfo.user.email.match(expression) && !cookieEmail) {
                setTimeout(() => {this.createModal();}, 5000);
            }
        }
    }

    createModal(){
        const newModal = new WindowModal();
        newModal.OnReady(() => {this.onCloseButton();});
        newModal.CreateWindowModal({
            idSelectorString: "idHotmailOutlookModal",
            dataTitle: `<div class="closeModal"></div>`,
            dataBody: `<div class="ho-modal-text"><p>Hola `+ this._modalInfo.user.name +`,</p><p>`+ this._modalInfo.firstText +`</p><p>`+ this._modalInfo.secondText +`</p><img src="`+ this._modalInfo.GifDesktop +`"></div>`,
            dataFooter: '<div class="ho-modal-footer"><input type="button" id="outlookBtn" name="" class="button ho-modal-outlook-btn" value="Ir a Outlook">' +
                        '<input type="button" id="idBtnCerrar" name="idBtnCerrar" class="button ho-modal-close-btn" value="Cerrar" /></div>'
        });
        jquery('.modal-title').css('border-bottom', 'none');
        jquery('.modal-content').addClass('ho-modal');
    }

    onCloseButton(){
        jquery('.closeModal, .ho-modal-close-btn').on('click', function (){
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
            jquery.publish(HabEvents.EventsEnum.ClickHotmailModal, 'cancel');
            CookieService.setCookie('outlook-hotmail', true);
            jquery('.modal-content').removeClass('ho-modal');
        });
        jquery('#outlookBtn').on('click', function(){
            window.open('https://outlook.live.com', '_blank');
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
            jquery.publish(HabEvents.EventsEnum.ClickHotmailModal, 'to-login');
            CookieService.setCookie('outlook-hotmail', true);    
            jquery('.modal-content').removeClass('ho-modal');
        });
    }

}

/* jshint unused: false */
const HotmailOutlookModalInstance = new HotmailOutlookModal(OutlookHotmailDTO); 